import React from "react";
import "components/Project-detail-shared/project-detail-shared.scss";
import "./project-stats.scss";

const ProjectStats = ({ stats }) => {
  if (!stats?.length) return null;

  return (
    <div className="pd-stats-inline-wrapper">
      <div className="pd-grid pd-stats-grid">
        {stats.map((stat, i) => (
          <div className="pd-card pd-stat-card wow fadeInUp" key={i} data-wow-delay={`${i * 0.1}s`}>
            {stat.customIcon ? (
              <span className="pd-icon-circle">
                <img src={stat.customIcon} alt={stat.label} style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
              </span>
            ) : stat.icon ? (
              <span className="pd-icon-circle">
                <i className={`fas ${stat.icon}`}></i>
              </span>
            ) : null}
            <h3 className="pd-stat-value color-font">{stat.value}</h3>
            <p className="pd-stat-label">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectStats;
